var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOtherIcon = function SvgOtherIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C9FE",
    d: "m1.684 17.743 5.507-5.507 5.506 5.507-5.506 5.506z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141E39",
    d: "M6.583 22.639 4.82 24.4a1.837 1.837 0 0 1-2.596 0l-.665-.665-.432-.432-.59-.59a1.835 1.835 0 0 1 0-2.596l1.761-1.762z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3C9FE",
    d: "m15.762 4.893 4.283 4.283a2.596 2.596 0 0 0 0-3.671l-.612-.612a2.595 2.595 0 0 0-3.671 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4277FC",
    d: "M12.09 17.131a9.24 9.24 0 0 1 7.369-2.668l2.422.22L10.254 3.058l.22 2.422a9.24 9.24 0 0 1-2.668 7.369z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#141E39",
    d: "M11.781.918a1.298 1.298 0 1 0-1.835 1.835L22.182 14.99a1.298 1.298 0 1 0 1.836-1.836z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4277FC",
    d: "m7.806 22.639 2.448-2.448 1.836 1.836a1.731 1.731 0 0 1-2.448 2.447z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOtherIcon);
export default ForwardRef;